import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

const initialState: {
  error: boolean;
  loading: boolean;
  token: string;
  errorMessage: string;
} = {
  error: false,
  loading: false,
  token: "",
  errorMessage: "",
};
const fetchAccessTokenReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ACCESS_TOKEN_STARTED:
      return {
        ...state,
        loading: true,
        error: false,
        token: "",
        errorMessage: "",
      };
    case actionTypes.FETCH_ACCESS_TOKEN_SUCCESS: {
      return updateObject(state, {
        loading: false,
        error: false,
        token: action.token,
        errorMessage: "",
      });
    }
    case actionTypes.FETCH_ACCESS_TOKEN_FAILED: {
      return updateObject(state, {
        error: true,
        errorMessage: action.errorMessage,
        loading: false,
        token: "",
      });
    }
    default:
      return state;
  }
};
export default fetchAccessTokenReducer;
